import { useGallery } from '@app/utils/hooks/useGallery';
import { AnyMedia, Product } from '@typings';

import { useProductDetailsLayoutContext } from '../context/ProductDetailsLayoutContext';
import { useProductDetailsVariantContext } from '../context/ProductDetailsVariantContext';

import { ProductDetailsGalleryDots } from './ProductDetailsGalleryDots';
import { ProductDetailsMedia } from './ProductDetailsMedia';

interface Props {
  activeMediaIndex: number;
  productDetails: Product.Standard;
  medias: AnyMedia[];
}

export const ProductDetailsGallery = ({ activeMediaIndex, productDetails, medias }: Props) => {
  const { handleMediaIndexChange } = useProductDetailsVariantContext();
  const { isDesktop, isTablet } = useProductDetailsLayoutContext();

  const { ref, handleScroll } = useGallery({
    activeIndex: activeMediaIndex,
    onChange: payload => {
      handleMediaIndexChange(payload);
    },
    orientation: isDesktop ? 'vertical' : 'horizontal',
    slidesCount: isTablet ? 2 : 1,
  });

  return (
    <div className="h-full w-full bg-neutral-96">
      <div
        ref={ref}
        key={productDetails.product}
        className="flex h-full w-full snap-x snap-mandatory overflow-y-auto no-scrollbar focus-visible:focus-outline lg:snap-y lg:flex-col"
        onScroll={handleScroll}
      >
        {medias.map((media, index) => (
          <ProductDetailsMedia key={index} media={media} className="mx-auto w-full shrink-0 snap-start sm:w-1/2 lg:w-full" />
        ))}
      </div>
      <ProductDetailsGalleryDots medias={medias} activeMediaIndex={activeMediaIndex} />
    </div>
  );
};
